module.exports = __webpack_public_path__ + "img/PersonalPoster_bg.1519ea52.png";